import { AddToBasketFailureKind } from '@scayle/storefront-nuxt'
import type { Composer } from '#i18n'

/**
 * Returns a translation key for a basket error message based on the provided error.
 *
 * @param error - The error to determine the error message key for
 * @returns The translation key corresponding to the error type
 */
export const getBasketToastErrorMessage = (
  error: unknown,
  i18n: Composer,
  productName?: string,
) => {
  if (error instanceof Error) {
    if (
      error.cause === AddToBasketFailureKind.ITEM_ADDED_WITH_REDUCED_QUANTITY
    ) {
      return i18n.t(
        'add_to_basket.notification.add_with_reduced_quantity_error',
      )
    } else if (error.cause === AddToBasketFailureKind.ITEM_UNAVAILABLE) {
      return i18n.t(
        'add_to_basket.notification.add_to_basket_variant_out_of_stock_error',
      )
    } else if (
      error.cause === AddToBasketFailureKind.MAXIMUM_ITEM_COUNT_REACHED
    ) {
      return i18n.t(
        'add_to_basket.notification.add_to_basket_max_basket_items_error',
      )
    }
  }
  return i18n.t('add_to_basket.notification.add_to_basket_error', {
    productName,
  })
}
